import { Author, Category } from '@/types/summary'
import Link from 'next/link'

interface Props {
  type: 'category' | 'author'
  values: Category[] | Author[]
  showBorder?: boolean
}
export const LabelValues: React.FC<Props> = ({
  type,
  values,
  showBorder = true,
}) => {
  if (!values || values.length === 0) {
    return null
  }
  return (
    <div
      className={`flex-1 ${
        showBorder ? 'border-b border-[#e6e6e6] border-dotted' : ''
      }`}
    >
      {values.map((v) => {
        return (
          <Link key={v.id} href={`/${type}/${v.id}`}>
            <div>
              <div className="inline-block px-2 mx-[1px] mb-[2px] text-[14px] text-[#50608b] bg-[#eef2fb] rounded-sm cursor-pointer">
                <span>{v.name}</span>
              </div>
            </div>
          </Link>
        )
      })}
    </div>
  )
}
